import { useReducer, useMemo, useCallback } from 'react';
import { PublicationContext } from './PublicationContext';
import { PublicationReducer } from './PublicationReducer';
import { Publication } from '../interfaces/Publication';

const INITIAL_STATE: Publication = {
  id: 0,
  title: "",
  coverImg: "",
  credits: "",
  creditsImg: "",
  sections: [],
  currentSection: 0
};

interface PublicationProviderProps {
  children: JSX.Element | JSX.Element[];
}

const PublicationProvider = ({ children }: PublicationProviderProps) => {
  const [publication, dispatch] = useReducer(PublicationReducer, INITIAL_STATE);

  // Aseguramos que la función no cambie en cada render
  const changePublication = useCallback((publication: Publication) => {
    dispatch({ type: 'change', payload: { publication } });
  }, []);

  // Memoizamos el value que se pasa al Provider
  const value = useMemo(
    () => ({
      publication,
      changePublication,
    }),
    [publication, changePublication]
  );

  return (
    <PublicationContext.Provider value={value}>
      {children}
    </PublicationContext.Provider>
  );
};

export default PublicationProvider;
